import React from 'react';
import { IconDotsHorizontal } from '../../../base/icons/svg';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from "../../../base/ui/constants.any";
const ParticipantActionEllipsis = ({ accessibilityLabel, onClick, participantID }) => (React.createElement(Button, { accessibilityLabel: accessibilityLabel, icon: IconDotsHorizontal, color: 'rgba(255, 255, 255, 0.1)', onClick: onClick, size: 'medium', type: BUTTON_TYPES.TERTIARY, testId: participantID ? `participant-more-options-${participantID}` : undefined }));
export default ParticipantActionEllipsis;
